import type { IbanTransfer } from 'types/Iban';
import type * as types from './types';


const initialState = {
    status: 'IDLE',
    projectId: 0,
    projectName: 'unknown',
    amountSought: 20000,
    addressSociety: {
        address: '',
        city: '',
        zip_code: '',
        country: '',
    },
    transId: 0,
    siren: '',
    vatNumber: '',
    verifyVatNumber: '',
    vatRate: 20,
    email: '',
    firstName: '',
    lastName: '',
    phone: '',
    address: {
        address: '',
        city: '',
        zip_code: '',
        country: '',
    },
    companyLegalName: '',
    fromCompany: true,
    isOwner: undefined,
    alreadyUsed: false,
    vatVerification: undefined,
    successCreateProject: undefined,
    successDownload: undefined,
    isUploading: undefined,
    isDownloading: undefined,
    transfer: undefined,
};

type UserAction = {
    type: typeof types[keyof typeof types];
    payload?: Partial<types.UserState> | { name: string; value: string; } | IbanTransfer;
};

export default function userReducer(state = initialState, action: UserAction) {
    const { type, payload } = action;
    switch (type) {
        case 'FETCH_LOCAL_DATA':
            return { ...state, ...payload };
        case 'FETCH_USER_DATA':
            return { ...state, ...payload, status: 'SUCCEEDED' };
        case 'SET_AUTH_DATA':
            return { ...state, ...payload };
        case 'RESET_CALL_CREATE_PROJECT':
            return {
                ...state,
                isUploading: false,
                successCreateProject: undefined,
                alreadyUsed: false,
            };
        case 'SEND_CREATE_PROJECT':
            return {
                ...state, isUploading: true, successCreateProject: undefined, alreadyUsed: false,
            };
        case 'CREATE_PROJECT_SUCCESS':
            return {
                ...state, ...payload,
            };
        case 'SOCKET_RECEIVED':
            return {
                ...state, ...payload, isUploading: false, successCreateProject: true,

            };
        case 'CREATE_PROJECT_FAILED':
            return { ...state, isUploading: false, successCreateProject: false };
        case 'CREATE_PROJECT_ALREADY_USED':
            return {
                ...state, isUploading: false, successCreateProject: false, alreadyUsed: true,
            };
        case 'GET_INVOICE':
            return { ...state, isDownloading: true, successDownload: false };
        case 'GET_INVOICE_FAILED':
            return { ...state, isDownloading: false, successDownload: false };
        case 'GET_INVOICE_SUCCESS':
            return { ...state, isDownloading: false, successDownload: true };
        case 'UPDATE_PROJECT_NAME':
            return { ...state, projectName: payload, companyLegalName: payload };
        case 'UPDATE_VAT_NUMBER':
            return { ...state, vatNumber: payload };
        case 'UPDATE_VAT_RATE':
            return { ...state, vatRate: payload };
        case 'UPDATE_PROJECT_ID':
            return { ...state, projectId: payload };
        case 'UPDATE_IS_OWNER':
            return { ...state, isOwner: payload };
        case 'UPDATE_SOCIETY_ADDRESS':
            if (payload && 'name' in payload && 'value' in payload) {
                return {
                    ...state,
                    addressSociety: { ...state.addressSociety, [payload.name]: payload.value },
                };
            }
            return;
        case 'UPDATE_USER_FROM_COMPANY':
            return { ...state, fromCompany: payload };
        case 'UPDATE_USER_ID':
            return { ...state, id: payload };
        case 'UPDATE_USER_FIRST_NAME':
            return { ...state, firstName: payload };
        case 'UPDATE_USER_LAST_NAME':
            return { ...state, lastName: payload };
        case 'UPDATE_USER_EMAIL':
            return { ...state, email: payload };
        case 'UPDATE_USER_ADDRESS':
            if (payload && 'name' in payload && 'value' in payload) {
                return { ...state, address: { ...state.address, [payload.name]: payload.value } };
            }
            return;
        case 'MAKE_PAYMENT_SUCCESS':
            return {
                ...state,
                transfer: payload,
            };
        default:
            return { ...state };
    }
}
